import React from 'react';

const IconlyCurvedBoldPaper = ({ width = 20, height = 20, fill = "#D9D9D9" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 20 20">
    <path
      fill={fill}
      fillRule="evenodd"
      d="M14.175 7.228a2.49 2.49 0 0 1-2.491-2.483V3.043l4.401 4.185h-1.91Zm-2.643 6.349h-4.5a.625.625 0 0 1 0-1.25h4.5a.625.625 0 1 1 0 1.25Zm-4.5-4.593h2.796a.625.625 0 0 1 0 1.25H7.03a.625.625 0 1 1 0-1.25Zm10.223-1.609c0-.033 0-.058-.009-.092-.025-.15-.05-.3-.075-.441a.428.428 0 0 0-.125-.234l-4.725-4.5A.382.382 0 0 0 12.096 2c-.141-.017-.291-.033-.441-.05-.025-.008-.059-.008-.084-.008a18.472 18.472 0 0 0-1.575-.067C4.53 1.875 2.588 4 2.588 10c0 5.992 1.942 8.125 7.408 8.125 5.475 0 7.417-2.133 7.417-8.125 0-1-.05-1.867-.158-2.625Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IconlyCurvedBoldPaper;